import {
  Alert,
  Box,
  Button,
  MenuItem,
  Paper,
  TextField,
} from "@mui/material";

export default function PetForm({
  availableQRCodes,
  countryCodes,
  editingId,
  fieldErrors,
  generalErrors,
  form,
  onCancel,
  onChange,
  onFileChange,
  onSubmit,
  photoFile,
}) {
  return (
    <Paper
      sx={{
        p: 3,
        borderRadius: "16px",
        border: "2px solid #e0f2e9",
        backgroundColor: "#fcffff",
      }}
    >
      <form onSubmit={onSubmit} encType="multipart/form-data">
        <Box display="flex" flexWrap="wrap" gap={2}>
          {generalErrors.length > 0 && (
            <Box width="100%">
              {generalErrors.map((msg, i) => (
                <Alert severity="error" key={i} sx={{ mb: 1 }}>
                  {msg}
                </Alert>
              ))}
            </Box>
          )}

          <TextField
            label="Codigo de mascota"
            name="pet_code"
            value={form.pet_code}
            onChange={onChange}
            type="number"
            error={Boolean(fieldErrors.pet_code)}
            helperText={fieldErrors.pet_code}
            fullWidth
            sx={{ "& .MuiOutlinedInput-root": { borderRadius: "12px" } }}
          />
          <TextField
            label="Nombre de la mascota"
            name="name"
            value={form.name}
            onChange={onChange}
            error={Boolean(fieldErrors.name)}
            helperText={fieldErrors.name}
            fullWidth
            sx={{ "& .MuiOutlinedInput-root": { borderRadius: "12px" } }}
          />
          <TextField
            label="Especie de la mascota"
            name="species"
            value={form.species}
            onChange={onChange}
            error={Boolean(fieldErrors.species)}
            helperText={fieldErrors.species}
            fullWidth
            sx={{ "& .MuiOutlinedInput-root": { borderRadius: "12px" } }}
          />
          <TextField
            label="Zona donde radica el dueno"
            name="zone"
            value={form.zone}
            onChange={onChange}
            error={Boolean(fieldErrors.zone)}
            helperText={fieldErrors.zone}
            fullWidth
            sx={{ "& .MuiOutlinedInput-root": { borderRadius: "12px" } }}
          />
          <TextField
            label="Nombre del dueno"
            name="contact_name"
            value={form.contact_name}
            onChange={onChange}
            error={Boolean(fieldErrors.contact_name)}
            helperText={fieldErrors.contact_name}
            fullWidth
            sx={{ "& .MuiOutlinedInput-root": { borderRadius: "12px" } }}
          />

          <Box display="flex" gap={1} width="100%">
            <TextField
              select
              label="Lada"
              name="primary_lada"
              value={form.primary_lada}
              onChange={onChange}
              sx={{
                width: "30%",
                "& .MuiOutlinedInput-root": { borderRadius: "12px" },
              }}
            >
              {countryCodes.map((c) => (
                <MenuItem key={c.code} value={c.code}>
                  {c.label} ({c.code})
                </MenuItem>
              ))}
            </TextField>

            <TextField
              label="Tel. Primario del dueno"
              name="primary_phone"
              value={form.primary_phone}
              onChange={onChange}
              error={Boolean(fieldErrors.primary_phone)}
              helperText={fieldErrors.primary_phone}
              fullWidth
              sx={{
                "& .MuiOutlinedInput-root": { borderRadius: "12px" },
              }}
            />
          </Box>

          <Box display="flex" gap={1} width="100%">
            <TextField
              select
              label="Lada"
              name="secondary_lada"
              value={form.secondary_lada}
              onChange={onChange}
              sx={{
                width: "30%",
                "& .MuiOutlinedInput-root": { borderRadius: "12px" },
              }}
            >
              {countryCodes.map((c) => (
                <MenuItem key={c.code} value={c.code}>
                  {c.label} ({c.code})
                </MenuItem>
              ))}
            </TextField>

            <TextField
              label="Tel. Secundario del dueno (Opcional)"
              name="secondary_phone"
              value={form.secondary_phone}
              onChange={onChange}
              error={Boolean(fieldErrors.secondary_phone)}
              helperText={fieldErrors.secondary_phone}
              fullWidth
              sx={{
                "& .MuiOutlinedInput-root": { borderRadius: "12px" },
              }}
            />
          </Box>

          <TextField
            label="Notas (Descripcion de la mascota, datos importantes...)"
            name="notes"
            value={form.notes}
            onChange={onChange}
            error={Boolean(fieldErrors.notes)}
            helperText={fieldErrors.notes}
            fullWidth
            multiline
            sx={{ "& .MuiOutlinedInput-root": { borderRadius: "12px" } }}
          />
          <TextField
            select
            label="Estado de la mascota. (En casa o Perdido)"
            name="status"
            value={form.status}
            onChange={onChange}
            error={Boolean(fieldErrors.status)}
            helperText={fieldErrors.status}
            fullWidth
            sx={{ "& .MuiOutlinedInput-root": { borderRadius: "12px" } }}
          >
            <MenuItem value="en_casa">En casa</MenuItem>
            <MenuItem value="perdido">Perdido</MenuItem>
          </TextField>

          <TextField
            select
            label="QR asignado"
            name="qr_code_id"
            value={form.qr_code_id ?? ""}
            onChange={onChange}
            error={Boolean(fieldErrors.qr_code_id)}
            helperText={fieldErrors.qr_code_id || "La mascota debe tener un unico QR activo."}
            fullWidth
            sx={{ "& .MuiOutlinedInput-root": { borderRadius: "12px" } }}
          >
            {availableQRCodes.map((qrCode) => (
              <MenuItem key={qrCode.id} value={qrCode.id}>
                {`${qrCode.label || `QR #${qrCode.id}`} - ${qrCode.url}`}
              </MenuItem>
            ))}
          </TextField>
          {availableQRCodes.length === 0 && (
            <Alert severity="warning" sx={{ width: "100%" }}>
              No hay QRs activos disponibles para asignar.
            </Alert>
          )}

          <Button
            variant="outlined"
            component="label"
            fullWidth
            sx={{
              mt: 2,
              py: 1.5,
              borderRadius: "50px",
              "&:hover": { backgroundColor: "inherit" },
            }}
          >
            {photoFile ? photoFile.name : "Seleccionar foto"}
            <input type="file" hidden onChange={onFileChange} />
          </Button>
          {fieldErrors.photo && (
            <Alert severity="error" sx={{ width: "100%" }}>
              {fieldErrors.photo}
            </Alert>
          )}
        </Box>
        <Box mt={2}>
          {editingId && (
            <Button
              variant="outlined"
              color="error"
              fullWidth
              onClick={onCancel}
              sx={{
                py: 1.5,
                borderRadius: "50px",
                "&:hover": { backgroundColor: "#ffebee" },
              }}
            >
              Cancelar
            </Button>
          )}
          <Button
            variant="contained"
            color="primary"
            type="submit"
            fullWidth
            sx={{
              mt: 2,
              py: 1.5,
              borderRadius: "50px",
              backgroundColor: "#1B8D4B",
              "&:hover": { backgroundColor: "#14703B" },
            }}
          >
            {editingId ? "Actualizar" : "Agregar"}
          </Button>
        </Box>
      </form>
    </Paper>
  );
}
